export const isPromise = (p: Promise<void> | void): p is Promise<void> =>
  !!(p && Object.prototype.toString.call(p) === '[object Promise]');
